export default __webpack_public_path__ + "static/careers-benefits-block1-icon05.url-f9f3c456ce6c14a970f58fd88095acfa.svg";